module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/aleg49-b009b0409a3acd11e130b8e54f11155a.jpg";